import { LOGOUT_USER } from "common/redux/constants";
import initialState from "./initialState";
import { reducer as saveCurrentLeadDataReducer } from './saveCurrentLeadData/reducer'
import { reducer as setAsignedOnlyReducer } from './setIsAssignedTab/reducer'
import { reducer as setIncludeClosedOlderThan60Reducer } from './setIncludeClosedOlderThan60/reducer'
import { reducer as checkAutoAssignLeadReducer } from './checkAutoAssignLead/reducer'
import { reducer as setGroupFiltersReducer } from './setGroupFilters/reducer'
import { reducer as saveIntervalReducer } from './saveInterval/reducer'
import { whatsappReducer } from "./whatsappConversation/reducer";
import { reducer as clearChat } from './clearChat/reducer'

//This array should be filled with reducers for the lead module
const reducers = [
  saveCurrentLeadDataReducer,
  setAsignedOnlyReducer,
  setIncludeClosedOlderThan60Reducer,
  checkAutoAssignLeadReducer,
  setGroupFiltersReducer,
  saveIntervalReducer,
  whatsappReducer,
  clearChat
]
export default function reducer(state = initialState, action = {}) {
  let newState;

  if (action.type === LOGOUT_USER) {
    newState = initialState;
  } else {
    newState = state;
  }
  
  return reducers.reduce((s, r) => r(s, action), newState);
}
